// pdfjs-dist 4.x compatibility shim for @react-pdf-viewer 3.12.
//
// @react-pdf-viewer 3.12 is the last (and now unmaintained) release; it targets
// pdfjs-dist 2.x/3.x. We force pdfjs-dist to a patched 4.x (see the `overrides`
// in package.json) to clear the "arbitrary JavaScript execution on a malicious
// PDF" advisory that affects every pdfjs <= 4.1.392.
//
// The only pdfjs API that @react-pdf-viewer uses on the active (canvas) render
// path and that 4.x removed is the standalone `renderTextLayer()` function,
// replaced in 4.x by the `TextLayer` class. This module re-exports everything
// from the real pdfjs build and adds a `renderTextLayer()` wrapper that adapts
// the old call signature/return shape onto the new class. A CRACO webpack alias
// (see craco.config.js) points the bare `pdfjs-dist` specifier at this file, so
// both our code and @react-pdf-viewer resolve to it, while deep imports such as
// `pdfjs-dist/build/pdf.mjs` still resolve to the real package.

import * as pdfjs from 'pdfjs-dist/build/pdf.mjs';

export * from 'pdfjs-dist/build/pdf.mjs';

export function renderTextLayer(params) {
  const { container, viewport } = params;

  // pdfjs 4.x sizes the text layer from the container's `--scale-factor` CSS
  // custom property. pdfjs 3.x did not need it, so @react-pdf-viewer never set
  // it; without it the (invisible) text-selection layer would be mis-scaled.
  if (container && viewport) {
    container.style.setProperty('--scale-factor', `${viewport.scale}`);
  }

  const textLayer = new pdfjs.TextLayer({
    // 3.x callers pass `textContent`; 4.x expects `textContentSource`.
    textContentSource: params.textContentSource ?? params.textContent,
    container,
    viewport,
  });

  // The old `renderTextLayer()` returned a task object exposing `.promise` and
  // `.cancel()`; the new `TextLayer` returns the promise from `.render()`.
  return {
    textDivs: textLayer.textDivs,
    textContentItemsStr: textLayer.textContentItemsStr,
    promise: textLayer.render(),
    cancel: () => textLayer.cancel(),
  };
}
